import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import './Modal.css';

function CustomModal({
  show,
  title,
  onClose,
  onAccept,
  acceptButtonText = 'OK',
}) {
  const footer = (
    <>
      <Button
        label='Cancel'
        icon='pi pi-times'
        onClick={onClose}
        className='p-button-outlined mr-2'
      />
      <Button
        label={acceptButtonText}
        icon='pi pi-check'
        onClick={onAccept}
        className='p-button-primary'
      />
    </>
  );

  return (
    <Dialog
      visible={show}
      onHide={onClose}
      header={title}
      modal
      style={{ width: '500px' }}
      footer={footer}
      position='center'
      draggable={false}
      resizable={false}
      closeOnEscape
    />
  );
}
export default CustomModal;
